<div class="task-container">
    <ng-container *ngIf="availableTasks.length > 0; else noTasks">
        <div class="task-list">

            <div class="task-image-container" *ngFor="let task of availableTasks; let i = index">
                <svg 
                    width="60" height="64" viewBox="0 0 60 64"
                    [ngClass]="{
                        'completed': isTaskCompleted(task)
                    }">
                    <path d="M30 0C30.575 0 31.15 0.125 31.675 0.3625L55.2125 10.35C57.9625 11.5125 60.0125 14.225 60 17.5C59.9375 29.9 54.8375 52.5875 33.3 62.9C31.2125 63.9 28.7875 63.9 26.7 62.9C5.1625 52.5875 0.0624958 29.9 -4.179e-06 17.5C-0.0125042 14.225 2.0375 11.5125 4.7875 10.35L28.3375 0.3625C28.85 0.125 29.425 0 30 0Z"/>
                </svg>
                <span>{{i+1}}</span>
            </div>
        </div>
    </ng-container>
    <ng-template #noTasks>
        <span class="no-tasks">{{'sebbie_ranking.no_tasks' | translate}}</span>
    </ng-template>
    <span class="title">Taken</span>
</div>
